import type { PlanType } from '@simplywallst/services/types/endpoints/getUacCheck';
import { GrandfatherCoupons } from '@/components/OurPlans/components/Plans/constants';

type CheckAprilPromoParams = {
  loggedIn: boolean;
  couponId?: string;
  userAccessPlanType?: PlanType;
  guestPlanType?: PlanType;
};

export const checkPaidUser = (planType: PlanType) =>
  ['premium', 'unlimited'].includes(planType);

export const checkAprilPromo = ({
  loggedIn,
  couponId = '',
  userAccessPlanType = '',
  guestPlanType = '',
}: CheckAprilPromoParams) => {
  const isGrandfatherCoupon = GrandfatherCoupons.includes(couponId);

  if (!loggedIn) {
    const isPaidLoggedOutUser = checkPaidUser(guestPlanType);
    return !isPaidLoggedOutUser;
  }

  const isPaidUser = checkPaidUser(userAccessPlanType);
  return !(isGrandfatherCoupon || isPaidUser);
};
